import { defineStore } from "pinia";
import { store } from "./index"
import { useTabbarsStore } from "./tabbars";
import { useGlobalConfigStoreHook } from './globalConfig';
import { joinPaths } from '@/utils';

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            token: '',
            userInfo: <UserInfo | null>null,
        }
    },

    getters: {
        getToken(state) {
            return state.token
        },
        getUserInfo(state) {
            return state.userInfo
        }
    },
    actions: {
        setToken(token: string) {
            this.token = token
        },
        setUserInfo(userInfo: any) {
            this.userInfo = userInfo
        },
        loginOut() {
            // 清空本地存储中的 token
            localStorage.removeItem('token')
            useTabbarsStore().removeAllTabItems()
            useGlobalConfigStoreHook().clearConfig()

            // 将 token 和 userInfo 清空
            this.setToken('')
            this.setUserInfo(null)

            // 使用硬跳转，确保 body 上通过 ShowModal 渲染的弹窗也会被彻底销毁
            window.location.replace('/login')
        }
    },
    persist: true,//开启持久化
});

export function useUserStoreHook() {
    return useUserStore(store)
}
